import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  List,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import apiHandler from "../common/api";
import CommonReactSelect from "../common/CommonReactSelect";
// import Select from "react-select";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useCheckUserPermission } from "../common/userPermission";
import LoadingSpinner from "../../InitialPage/Sidebar/LoadingSpinner";

const PortalPermissionTemplate = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const uPermisson = useSelector((state) => state.userpermission);
  const userData = useSelector((state) => state.user_data);
  const navigate = useNavigate();

  const MySwal = withReactContent(Swal);

  const [selectedTemplateId, setSelectedTemplateId] = useState(0);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [newTemplateName, setNewTemplateName] = useState("");
  const [showTemplateInput, setShowTemplateInput] = useState(false);
  const [durationPlans, setDurationPlans] = useState([]);

  const [formValues, setFormValues] = useState({
    subscriptionName: "",
    isSubscription: 0,
    freeTrialDays: "",
    stripeProductId: "",
    commissionPercentage: 0,
  });

  const [loading, setLoading] = useState(false);

  console.log(durationPlans, "durationPlans 98");
  console.log(templateList, "templateList");
  console.log(selectedPermissions, "selectedPermissions");

  const fetchTemplates = async () => {
    await apiHandler({ method: "GET", route: "auth/getpermissiontemplates" })
      .then((response) => {
        setTemplateList(response.ResponseData);
      })
      .catch((error) => {
        console.error("Error fetching templates:", error);
      });
  };

  const getSuscribePriceByTempId = async (templateId) => {
    await apiHandler({
      method: "GET",
      route: `auth/getSuscribePriceByTempId?templateId=${templateId}`,
    })
      .then((response) => {
        if (response.ResponseCode === "SUCCESS") {
          const durationPriceData = response.ResponseData;
          const updatePriceData = durationPlans.map((plan) => {
            const matchedData = durationPriceData.find(
              (data) => data.durationId === plan.durationId
            );
            if (matchedData) {
              return {
                ...plan,
                durationInDays: matchedData.durationInDays,
                price: matchedData.price,
                discountedPrice: matchedData.discountPrice,
                id: matchedData.id,
                oldDurationInDays: matchedData.durationInDays,
                oldPrice: matchedData.price,
                oldDiscountedPrice: matchedData.discountPrice,
                stripePriceId: matchedData.stripePriceId,
                isActive: matchedData.isActive || 0,
                TotalMassageLimit: matchedData.TotalMassageLimit || 0,
                isDefaultAutoPaid:
                  matchedData.isDefaultAutoPaid ||
                  matchedData.isAutoPaid ||
                  matchedData.isDefault ||
                  0,
                isAutoPaid:
                  matchedData.isAutoPaid ||
                  matchedData.isDefaultAutoPaid ||
                  matchedData.isDefault ||
                  0,
                isDefault:
                  matchedData.isDefault ||
                  matchedData.isDefaultAutoPaid ||
                  matchedData.isAutoPaid ||
                  0,
              };
            }
            return plan;
          });

          console.log(updatePriceData, "updatePriceDatacheck");
          setDurationPlans([]);

          setDurationPlans(updatePriceData);
        } else {
          console.log(response.ResponseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching subscription prices:", error);
      });
  };

  const fetchSubscriptionPlanDuration = async () => {
    const multipleTablesData = await apiHandler({
      method: "GET",
      route: "Business/getMultipleTablesData",
      payload: { tableNames: "subscriptionPlanDuration" }, // make sure dont add space in the string and its correct.
    });
    if (multipleTablesData.ResponseCode === "SUCCESS") {
      if (
        Array.isArray(multipleTablesData.ResponseData[0]) &&
        multipleTablesData.ResponseData[0].length > 0
      ) {
        const durationData = multipleTablesData.ResponseData[0]
          .filter((el) => el.isDeleted !== 1) // Exclude deleted entries
          .map((el) => ({
            durationId: el.id,
            label: el.label || "",
            value: el.value || "",
            durationInDays: el.durationInDays || 0,
            price: "",
            discountedPrice: "",
            id: 0,
            isActive: 0,
            TotalMassageLimit: 0,
            isDefaultAutoPaid: 0,
            isAutoPaid: 0,
            isDefault: 0,
          }));
        setDurationPlans(durationData);
      } else {
        console.warn("No valid subscription plan duration data found.");
      }
    } else {
      console.log(multipleTablesData, "data");
    }
  };

  useEffect(() => {
    fetchTemplates();
    fetchSubscriptionPlanDuration();
  }, []);

  useEffect(() => {
    if (selectedTemplateId > 0) {
      setSelectedPermissions(
        templateList
          ?.find((el) => el.value === selectedTemplateId)
          ?.permissions.split(",")
          .map(Number) || []
      );

      setNewTemplateName(
        templateList?.find((el) => el.value === selectedTemplateId)?.label || ""
      );
      setShowTemplateInput(false);

      const tempdata = templateList?.find(
        (el) => el.value === selectedTemplateId
      );

      if (tempdata) {
        setFormValues((prev) => ({
          ...prev,
          isSubscription: tempdata?.isSubscription,
          subscriptionName: tempdata?.subscriptionName,
          stripeProductId: tempdata?.stripeProductId,
          freeTrialDays: tempdata?.freeTrialDays,
          commissionPercentage: tempdata?.commissionPercentage || 0,

        }));

        getSuscribePriceByTempId(selectedTemplateId);
      } else {
        setFormValues((prev) => ({
          ...prev,
          isSubscription: 0,
          subscriptionName: "",
          stripeProductId: "",
          freeTrialDays: "",
          commissionPercentage : 0
        }));
        fetchSubscriptionPlanDuration();
      }
    }
  }, [selectedTemplateId]);

  const groupedPermissions = uPermisson.reduce((acc, permission) => {
    if (!acc[permission.moduleName]) {
      acc[permission.moduleName] = [];
    }
    acc[permission.moduleName].push(permission);
    return acc;
  }, {});

  const handleCheckboxChange = (id) => {
    setSelectedPermissions((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const handleSaveTemplate = async () => {
    setLoading(true);

    // const hasDefaultAutoPaidPlan = durationPlans?.some(
    //   (plan) =>
    //     Number(
    //       plan.isDefaultAutoPaid || plan.isAutoPaid || plan.isDefault || 0
    //     ) === 1
    // );

    // if (formValues.isSubscription === 1 && durationPlans.length > 0 && !hasDefaultAutoPaidPlan) {
    //   setLoading(false);
    //   MySwal.fire({
    //     icon: "warning",
    //     title: "Select a default plan",
    //     text: "Please choose one plan as the default auto-paid option for this subscription.",
    //     confirmButtonText: "OK",
    //     customClass: {
    //       confirmButton: "btn btn-warning",
    //     },
    //   });
    //   return;
    // }

    // const isRestrict = durationPlans?.some(
    //   (plan) => plan.isActive == 1 && Number(plan.discountedPrice || 0) <= 0
    // );

    const isRestrict = durationPlans?.some(
      (plan) => plan.isActive == 1 && Number(plan.price || 0) <= 0
    );
    
    console.log(isRestrict, "isRestrict")

    if (isRestrict) {
      setLoading(false);
      MySwal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please ensure all active plans have valid duration and price.",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-error",
        },
      });
      return;
    }


    await apiHandler({
      method: "POST",
      route: "auth/upsertpermissiontemplate",
      payload: {
        templateId: selectedTemplateId,
        templateName: newTemplateName,
        permissions: selectedPermissions,
        isSubscription: formValues.isSubscription,
        freeTrialDays: formValues.freeTrialDays || "",
        subscriptionName: formValues.subscriptionName,
        stripeProductId: formValues.stripeProductId,
        durationPlans: durationPlans,
        commissionPercentage: formValues?.commissionPercentage,
        isDefaultAutoPaid: durationPlans?.some(
          (plan) =>
            Number(
              plan.isDefaultAutoPaid ??
              plan.isAutoPaid ??
              plan.isDefault ??
              0
            ) === 1
        )
          ? 1
          : 0,
      },
    })
      .then((res) => {
        console.log(res, "response check");
        if (res.ResponseCode === "SUCCESS") {
          setLoading(false);
          fetchTemplates();
          fetchSubscriptionPlanDuration();
          setNewTemplateName("");
          setShowTemplateInput(false);
          setSelectedTemplateId(0);
          setSelectedPermissions([]);
          setFormValues({
            subscriptionName: "",
            stripeProductId: "",
            isSubscription: 0,
            freeTrialDays: "",
          });
          MySwal.fire({
            title: "Submited!",
            text: "Permission Template has been Saved.",
            className: "btn btn-success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else {
          setLoading(false);
          console.log(res.ResponseMessage);
          MySwal.fire({
            title: "Error!",
            text: res.ResponseMessage,
            className: "btn btn-error",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-error",
            },
          });
        }
      })
      .catch((error) => {
        console.error("Error saving template:", error);
      });
  };

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleCreateTemplate = () => {
    setSelectedTemplateId(0);
    // setSelectedPermissions([]);

    setNewTemplateName("");

    setShowTemplateInput(!showTemplateInput);
    setFormValues((prev) => ({
      ...prev,
      isSubscription: 0, //prev.isSubscription === 1 ? 0 : 1
      subscriptionName: "",
      stripeProductId: "",
      freeTrialDays: "",
    }));
    fetchSubscriptionPlanDuration();

    setSelectedPermissions(
      templateList
        ?.find((el) => el.value === 4)
        ?.permissions.split(",")
        .map(Number) || []
    );
  };

  const showConfirmationAlert = () => {
    newTemplateName
      ? MySwal.fire({
        title: "Are you sure?",
        text: "You want to save this changes!",
        showCancelButton: true,
        confirmButtonColor: "#00ff00",
        confirmButtonText: "Yes, Save it!",
        cancelButtonColor: "#ff0000",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await handleSaveTemplate();
        } else {
          MySwal.close();
        }
      })
      : MySwal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Insert Template Name!",
      });
  };

  const handleDeleteTemplateAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this template?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, Delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        await apiHandler({
          method: "POST",
          route: "Superadmin/deletePermissonTemplateById",
          payload: {
            templateId: selectedTemplateId,
            loginuserid: userData?.id,
          },
        })
          .then((res) => {
            setLoading(false);
            if (res.ResponseCode === "SUCCESS") {
              MySwal.fire({
                title: "Deleted!",
                text: "Template has been deleted.",
                icon: "success",
                confirmButtonText: "OK",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              fetchTemplates();
              fetchSubscriptionPlanDuration();
              setSelectedTemplateId(0);
              setSelectedPermissions([]);
              setNewTemplateName("");
              setShowTemplateInput(false);
              setFormValues({
                subscriptionName: "",
                stripeProductId: "",
                isSubscription: 0,
                freeTrialDays: "",
              });
            } else {
              MySwal.fire({
                title: "Error!",
                text: res.ResponseMessage,
                icon: "error",
                confirmButtonText: "OK",
                customClass: {
                  confirmButton: "btn btn-error",
                },
              });
            }
          })
          .catch((error) => {
            setLoading(false);
            MySwal.fire({
              title: "Error!",
              text: "Failed to delete template.",
              icon: "error",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn btn-error",
              },
            });
            console.error("Error deleting template:", error);
          });
      } else {
        MySwal.close();
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedPermissions.length === uPermisson.length) {
      setSelectedPermissions([]);
    } else {
      setSelectedPermissions(uPermisson.map((p) => p.permissionId));
    }
  };

  const handleSectionSelectAll = (moduleName) => {
    const sectionPermissions = groupedPermissions[moduleName].map(
      (p) => p.permissionId
    );
    const isAllSelected = sectionPermissions.every((id) =>
      selectedPermissions.includes(id)
    );

    if (isAllSelected) {
      setSelectedPermissions((prev) =>
        prev.filter((id) => !sectionPermissions.includes(id))
      );
    } else {
      setSelectedPermissions((prev) => [
        ...new Set([...prev, ...sectionPermissions]),
      ]);
    }
  };

  console.log(durationPlans, "durationPlans");

  console.log(formValues, "formValues check");

  const handleFormChange = (field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleDurationInputChange = (index, field, value) => {
    const updatedPlans = [...durationPlans];
    updatedPlans[index][field] = value;
    setDurationPlans(updatedPlans);
  };

  // const handleDefaultAutoPaidChange = (index, checked) => {
  //   const updatedPlans = durationPlans.map((plan, planIndex) => ({
  //     ...plan,
  //     isDefaultAutoPaid: planIndex === index && checked ? 1 : 0,
  //     isAutoPaid: planIndex === index && checked ? 1 : 0,
  //     isDefault: planIndex === index && checked ? 1 : 0,
  //   }));

  //   setDurationPlans(updatedPlans);
  // };

  // In your component, add:
  console.log("durationPlans state:", durationPlans);
  console.log("isSubscription:", formValues?.isSubscription);
  console.log("selectedTemplateId:", selectedTemplateId);

  // In getSuscribePriceByTempId function:
  console.log("Before clearing durationPlans:", durationPlans);

  // In fetchSubscriptionPlanDuration function:

  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="d-flex flex-wrap page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Permission Template</h4>
                <h6>Manage Permission Templates</h6>
              </div>
            </div>
            <ul className="d-flex ms-auto flex-wrap table-top-head">
              <li>
                <CommonReactSelect
                  options={templateList}
                  placeholder="Select Template"
                  value={
                    selectedTemplateId
                      ? templateList?.find(
                        (el) => el.value === selectedTemplateId
                      )
                      : null
                  }
                  onChange={(e) => setSelectedTemplateId(e ? e.value : 0)}
                  required={true}
                />
              </li>
              <li>
                <button
                  className="btn btn-outline-primary btn-md me-2 d-flex align-items-center"
                  onClick={() => handleCreateTemplate()}
                >
                  Create Template
                </button>
              </li>
              {useCheckUserPermission(route.permissions) && (
                <li>
                  <div className="page-btn">
                    <button
                      onClick={() => navigate(route.permissions)}
                      className="btn btn-primary btn-md me-2"
                    >
                      <ArrowLeft className="custome-white-color me-2" />
                      Permission
                    </button>
                  </div>
                </li>
              )}
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Collapse"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => dispatch(setToogleHeader(!data))}
                  >
                    <ChevronUp className="feather-chevron-up" />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          {showTemplateInput && (
            <div className="d-flex mb-3 col-md-4">
              <input
                type="text"
                className="form-control"
                placeholder="Enter template name"
                value={newTemplateName}
                onChange={(e) => setNewTemplateName(e.target.value)}
              />
              <button
                className="btn btn-success ms-2"
                onClick={showConfirmationAlert}
              >
                Create
              </button>
            </div>
          )}

          <div className="row mb-3 align-items-center">
            <input
              className="col-md-1 ms-3"
              type="checkbox"
              style={{ width: "20px", height: "20px" }}
              onChange={(e) =>
                setFormValues((prev) => ({
                  ...prev,
                  isSubscription: e.target.checked ? 1 : 0,
                }))
              }
              checked={formValues?.isSubscription === 1}
            />
            <strong className="col-md-6"> Is Subscription </strong>
            {/* <h3 className="col-md-4">{selectedTemplateId}</h3> */}
            {selectedTemplateId > 0 && selectedTemplateId != 4 && (
              <div className="col-md-5">
                <button
                  className="btn btn-outline-primary btn-md me-2 d-flex align-items-center"
                  onClick={() => handleDeleteTemplateAlert()}
                >
                  Delete Template
                </button>
              </div>
            )}

            {selectedTemplateId == 4 && (
              <div className="col-md-4 d-flex align-items-center">
                <div className="col-3">
                  <label
                    className="form-label mb-0"
                    style={{ width: "fit-content" }}
                  >
                    Trial Days
                  </label>
                </div>
                <div className="col-9">
                  <input
                    type="number"
                    className="form-control"
                    value={formValues?.freeTrialDays}
                    onChange={(e) =>
                      setFormValues((prev) => ({
                        ...prev,
                        freeTrialDays: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>
            )}
          </div>

          {formValues?.isSubscription == 1 ? (
            <>
              <div className="p-3 border rounded shadow-sm mb-3">
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <div className="d-flex justify-content-between">
                        <label htmlFor="subscriptionName" className="form-label">
                          Subscription Name{" "}
                        </label>
                        {formValues?.stripeProductId && (
                          <span>
                            <strong>Stripe Product Id: </strong>
                            {formValues?.stripeProductId}
                          </span>
                        )}
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="subscriptionName"
                        placeholder="Enter subscription name"
                        value={formValues.subscriptionName}
                        onChange={(e) =>
                          handleFormChange("subscriptionName", e.target.value)
                        }
                      />


                    </div>

                  </div>
                </div>

                <div className="row mb-3">
                  <label className=" col-md-1">Commission</label>
                  <div className="col-md-1">
                    <input
                      type="text"
                      className="form-control "
                      value={formValues.commissionPercentage}
                      onChange={(e) =>
                        handleFormChange("commissionPercentage", e.target.value)
                      }
                    />
                  </div>
                </div>

                {/* Add loading or empty state check */}
                {durationPlans.length === 0 ? (
                  <div className="text-center p-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading subscription plans...</p>
                  </div>
                ) : (
                  durationPlans.map((plan, index) => (
                    <div className="row mb-3" key={index}>
                      {/* Rest of your code remains the same */}
                      <div className="col-md-12">
                        <div className="d-flex align-items-center flex-wrap gap-3">
                          <h6 className="fw-bold mb-0">{plan.label} Plan</h6>
                          <div className="d-flex align-items-center">
                            <input
                              className="col-md-1 ms-3"
                              type="checkbox"
                              style={{
                                width: "10px",
                                height: "10px",
                                marginRight: "5px",
                              }}
                              onChange={(e) =>
                                handleDurationInputChange(
                                  index,
                                  "isActive",
                                  e.target.checked ? 1 : 0
                                )
                              }
                              checked={plan.isActive === 1}
                            />
                            <span>isActive</span>
                          </div>
                         {/* <div className="d-flex align-items-center">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={plan.isDefaultAutoPaid === 1}
                              onChange={(e) =>
                                handleDefaultAutoPaidChange(index, e.target.checked)
                              }
                            />
                            <label className="form-label mb-0 ms-2">
                              Default Auto Paid
                            </label>
                          </div> */}
                        </div>
                        {plan.stripePriceId && (
                          <span>
                            <strong>Stripe Price Id: </strong>
                            {plan.stripePriceId}
                          </span>
                        )}
                      </div>

                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Duration (Days)</label>
                          <input
                            type="number"
                            className="form-control"
                            value={plan.durationInDays}
                            onChange={(e) =>
                              handleDurationInputChange(
                                index,
                                "durationInDays",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Price</label>
                          <input
                            type="number"
                            className="form-control"
                            value={plan.price}
                            onChange={(e) =>
                              handleDurationInputChange(
                                index,
                                "price",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Discounted Price</label>
                          <input
                            type="number"
                            className="form-control"
                            value={plan.discountedPrice}
                            onChange={(e) =>
                              handleDurationInputChange(
                                index,
                                "discountedPrice",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Massage You Get</label>
                          <input
                            type="number"
                            className="form-control"
                            value={plan.TotalMassageLimit}
                            onChange={(e) =>
                              handleDurationInputChange(
                                index,
                                "TotalMassageLimit",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </>
          ) : (
            <> </>
          )}

          <form>
            <div className="card">
              <div className="card-body add-product pb-0">
                <label className="checkboxs col-auto">
                  <input
                    type="checkbox"
                    checked={selectedPermissions.length === uPermisson.length}
                    onChange={handleSelectAll}
                  />
                  <span className="checkmarks" />
                  Select All Permissions
                </label>
                {Object.entries(groupedPermissions).map(
                  ([moduleName, permissions], index) => (
                    <>
                      <input
                        type="checkbox"
                        onClick={(event) => event.stopPropagation()}
                        checked={permissions.every((p) =>
                          selectedPermissions.includes(p.permissionId)
                        )}
                        onChange={(event) => {
                          event.stopPropagation(); // Prevent accordion toggle
                          handleSectionSelectAll(moduleName);
                        }}
                      />
                      <span
                        style={{ fontSize: "16px", marginLeft: "12px" }}
                        className="ml-2"
                      >
                        {" "}
                        Select All
                      </span>

                      <div
                        key={index}
                        className="accordion-card-one accordion"
                        id={`heading-${index}`}
                      >
                        <div className="accordion-item">
                          <div className="accordion-header" id="headingFour">
                            <div
                              className="accordion-button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse-${index}`}
                              aria-controls={`collapse-${index}`}
                            >
                              <div className="text-editor add-list">
                                <div className="addproduct-icon list">
                                  <h5>
                                    <List className="add-info" />
                                    <span>{moduleName}</span>
                                  </h5>
                                  <Link to="#">
                                    <ChevronDown className="chevron-down-add" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id={`collapse-${index}`}
                            className="accordion-collapse collapse show"
                            aria-labelledby={`heading-${index}`}
                            data-bs-parent="#permissionAccordion"
                          >
                            <div className="accordion-body">
                              <div className="text-editor add-list add">
                                <div className="custom-filed">
                                  <div className="input-block add-lists row w-100">
                                    {permissions.map((permission) => (
                                      <label
                                        className="checkboxs col-auto"
                                        key={permission.permissionId}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={selectedPermissions.includes(
                                            permission.permissionId
                                          )}
                                          onChange={() =>
                                            handleCheckboxChange(
                                              permission.permissionId
                                            )
                                          }
                                        />
                                        <span className="checkmarks" />
                                        {permission.permissionName}
                                      </label>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                )}
              </div>
            </div>
            {!showTemplateInput && (
              <div className="col-lg-12">
                <div className="btn-addproduct mb-4">
                  <button
                    type="button"
                    className="btn btn-cancel me-2"
                    onClick={() => {
                      setSelectedTemplateId(0);
                      setSelectedPermissions([]);
                      setNewTemplateName("");
                      setShowTemplateInput(false);
                    }}
                  >
                    Cancel
                  </button>
                  {selectedTemplateId > 0 && (
                    <Link
                      to="#"
                      className="btn btn-submit"
                      onClick={showConfirmationAlert}
                    >
                      Save
                    </Link>
                  )}
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default PortalPermissionTemplate;
